// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   KeyframeEditingSidebar Styles
   
   Design System: Uses CSS variables from colors.css
   - Neutral base palette, accent reserved for primary actions only
   - Flat surfaces with borders (no gradients)
   - Minimal shadows
   ====================== */

/* ======================
   LAYOUT
   ====================== */

.keyframe-editing-sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  max-height: 100vh;
  max-height: 100dvh; /* Dynamic viewport height for mobile */
  overflow: hidden;
  border-left: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
}

.keyframe-editing-sidebar .sidebar-header {
  flex: 0 0 auto;
  padding: 12px 16px;
  border-bottom: 1px solid var(--color-border-input);
}

.keyframe-editing-sidebar .header-content {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.keyframe-editing-sidebar .sidebar-header-title-container {
  display: flex;
  flex: 1 1;
  align-items: center;
  min-width: 0;
}

.keyframe-editing-sidebar .config-back-button {
  display: inline-flex;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 1px;
  border-radius: 7px;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.1s ease;
}

.keyframe-editing-sidebar .config-back-button:hover {
  border-color: var(--color-border-input);
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.keyframe-editing-sidebar .config-back-button:active {
  background: var(--color-bg-input);
  transform: translateY(1px);
}

.keyframe-editing-sidebar .config-back-button:focus-visible {
  outline: 2px solid var(--color-text-secondary);
  outline-offset: 2px;
}

.keyframe-editing-content {
  flex: 1 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
  min-height: 0;
}

.keyframe-section-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--color-text-secondary);
  margin: 0;
}

/* ======================
   TOOLS SECTION
   ====================== */

.keyframe-tools-section {
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  padding: 12px;
}

.keyframe-tools-section .keyframe-section-title {
  margin-bottom: 10px;
}

.keyframe-tools-grid {
  display: grid;
  gap: 4px;
}

.keyframe-tool-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
  font-family: inherit;
  aspect-ratio: 1;
}

.keyframe-tool-button:hover:not(.disabled) {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.keyframe-tool-button.active {
  background: var(--color-bg-input);
  border-color: var(--color-border-input);
  color: var(--color-text-primary);
}

.keyframe-tool-button.disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

/* ======================
   COLOR PICKER
   ====================== */

.keyframe-color-picker-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--color-border-input);
}

.keyframe-color-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-secondary);
}

.keyframe-color-picker {
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  cursor: pointer;
  background: transparent;
}

.keyframe-color-picker::-webkit-color-swatch-wrapper {
  padding: 2px;
}

.keyframe-color-picker::-webkit-color-swatch {
  border-radius: 4px;
  border: none;
}

/* ======================
   PEN OPTIONS (Color + Eraser)
   ====================== */

.keyframe-pen-options {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--color-border-input);
}

.keyframe-pen-options .keyframe-color-picker-wrapper {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
  flex: 1 1;
}

.keyframe-eraser-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
  font-family: inherit;
  flex-shrink: 0;
}

.keyframe-eraser-button:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

/* Eraser mode active state */
.keyframe-eraser-active {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--color-border-input);
}

.keyframe-eraser-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-secondary);
}

.keyframe-back-to-pen-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 5px;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  font-family: inherit;
  font-size: 11px;
  font-weight: 500;
}

.keyframe-back-to-pen-button:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

/* ======================
   VERSIONS SECTION
   ====================== */

.keyframe-versions-section {
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.keyframe-version-restore-btn {
  border: 1px solid var(--color-border-input);
  border-radius: 5px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 11px;
  font-weight: 600;
  padding: 6px 10px;
  cursor: pointer;
}

.keyframe-version-restore-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.keyframe-version-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.keyframe-version-item {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  padding: 0;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  overflow: hidden;
}

.keyframe-version-item:hover {
  background: var(--color-bg-user-bubble);
}

.keyframe-version-item.selected {
  background: var(--color-bg-user-bubble);
  border-color: var(--color-text-primary);
}

.keyframe-version-item.current {
  border-color: var(--color-text-secondary);
}

.keyframe-version-item-rail {
  display: none;
}

.keyframe-version-item.current .keyframe-version-item-rail {
  display: none;
}

.keyframe-version-item-thumb {
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: 6px 6px 0 0;
  border: none;
  border-bottom: 1px solid var(--color-border-input);
}

.keyframe-version-item-copy {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  min-width: 0;
}

.keyframe-version-item-label {
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 600;
}

.keyframe-version-item-time {
  color: var(--color-text-secondary);
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.keyframe-version-current-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--color-text-primary);
  margin-left: auto;
}

/* ======================
   HISTORY SECTION
   ====================== */

.keyframe-history-section {
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  padding: 12px;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.keyframe-history-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.keyframe-history-actions {
  display: flex;
  gap: 4px;
}

.keyframe-history-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid var(--color-border-input);
  border-radius: 5px;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  font-family: inherit;
}

.keyframe-history-action-btn:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.keyframe-history-action-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.keyframe-history-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
  max-height: 180px;
}

.keyframe-history-empty {
  text-align: center;
  padding: 20px 8px;
  color: var(--color-text-secondary);
}

.keyframe-history-empty p {
  margin: 0;
  font-size: 13px;
}

.keyframe-history-empty-hint {
  font-size: 11px !important;
  margin-top: 4px !important;
  opacity: 0.6;
}

.keyframe-history-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 5px;
  background: transparent;
  border: none;
  transition: background 0.15s ease;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  width: 100%;
}

.keyframe-history-item:hover {
  background: var(--color-bg-user-bubble);
}

.keyframe-history-item.current {
  background: var(--color-bg-input);
}

.keyframe-history-item.future {
  opacity: 0.4;
}

.keyframe-history-item.future:hover {
  opacity: 0.6;
}

.keyframe-history-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
  min-width: 0;
}

.keyframe-history-current-badge {
  font-size: 9px;
  font-weight: 600;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 2px 5px;
  background: var(--color-bg-user-bubble);
  border-radius: 3px;
  flex-shrink: 0;
}

/* ======================
   SAVE BAR
   ====================== */

.keyframe-save-bar {
  position: sticky;
  bottom: 0;
  padding: 12px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.keyframe-export-button {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.15s ease, opacity 0.15s ease;
  font-family: inherit;
}

.keyframe-export-button:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
}

.keyframe-export-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.keyframe-save-button {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
  font-family: inherit;
}

.keyframe-save-button:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
}

.keyframe-save-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ======================
   STICKER/ASSETS SECTION
   ====================== */

.keyframe-sticker-assets-wrapper {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--color-border-input);
  max-height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
}

.keyframe-sticker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.keyframe-sticker-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-secondary);
}

.keyframe-create-asset-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 5px;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  font-family: inherit;
  font-size: 11px;
  font-weight: 500;
}

.keyframe-create-asset-button:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.keyframe-sticker-assets-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  width: 100%;
  max-width: 100%;
}

.keyframe-sticker-asset-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 8px;
  background: transparent;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  min-width: 0;
  box-sizing: border-box;
}

.keyframe-sticker-asset-card:hover:not(.disabled) {
  background: var(--color-bg-user-bubble);
}

.keyframe-sticker-asset-card.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.keyframe-sticker-asset-image-wrapper {
  width: 100%;
  aspect-ratio: 1;
  border-radius: 4px;
  overflow: hidden;
  background: var(--color-bg-input);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  border: 1px solid var(--color-border-input);
}

.keyframe-sticker-asset-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.keyframe-sticker-asset-placeholder {
  color: var(--color-text-secondary);
  opacity: 0.5;
}

.keyframe-sticker-asset-name {
  font-size: 11px;
  font-weight: 500;
  color: var(--color-text-secondary);
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  width: 100%;
  min-width: 0;
  line-height: 1.2;
}

.keyframe-sticker-empty {
  text-align: center;
  padding: 16px 8px;
  color: var(--color-text-secondary);
}

.keyframe-sticker-empty p {
  margin: 0;
  font-size: 13px;
}

.keyframe-sticker-empty-hint {
  font-size: 11px !important;
  margin-top: 4px !important;
  opacity: 0.6;
}

/* ======================
   DROPDOWN MENU
   ====================== */

.keyframe-assets-dropdown-content {
  min-width: 160px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  padding: 4px;
  z-index: 1000;
}

.keyframe-assets-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 5px;
  font-size: 13px;
  color: var(--color-text-primary);
  cursor: pointer;
  outline: none;
  transition: background 0.15s ease;
}

.keyframe-assets-dropdown-item[data-highlighted] {
  background: var(--color-bg-user-bubble);
}

.keyframe-assets-dropdown-icon {
  color: var(--color-text-secondary);
  flex-shrink: 0;
}

/* ======================
   COLOR ADJUSTMENTS
   ====================== */

.keyframe-adjustments-wrapper {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--color-border-input);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.keyframe-adjustments-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-secondary);
  margin-bottom: 8px;
  display: block;
}

/* Color Wheel */
.keyframe-color-wheel-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.keyframe-color-wheel {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  position: relative;
  cursor: crosshair;
  border: 1px solid var(--color-border-input);
  overflow: hidden;
  background: var(--color-bg-input);
}

.keyframe-color-wheel-gradient {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: 
    radial-gradient(circle at center, transparent 0%, transparent 60%, var(--color-bg-input) 100%),
    conic-gradient(
      from 180deg,
      #ff9500 0deg,      /* warm/orange */
      #ff2d92 90deg,     /* magenta */
      #5856d6 180deg,    /* cool/blue */
      #34c759 270deg,    /* green */
      #ff9500 360deg     /* warm/orange */
    );
  opacity: 0.6;
}

.keyframe-color-wheel-crosshair {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.keyframe-color-wheel-crosshair-h,
.keyframe-color-wheel-crosshair-v {
  position: absolute;
  background: var(--color-border-input);
}

.keyframe-color-wheel-crosshair-h {
  left: 10%;
  right: 10%;
  top: 50%;
  height: 1px;
  transform: translateY(-50%);
}

.keyframe-color-wheel-crosshair-v {
  top: 10%;
  bottom: 10%;
  left: 50%;
  width: 1px;
  transform: translateX(-50%);
}

.keyframe-color-wheel-indicator {
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--color-text-primary);
  border: 2px solid var(--color-bg-canvas-surface);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transform: translate(-50%, -50%);
  pointer-events: none;
}

/* Adjustment Sliders */
.keyframe-adjustments-sliders {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.keyframe-adjustment-slider {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.keyframe-adjustment-slider-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.keyframe-adjustment-slider-label {
  font-size: 11px;
  font-weight: 500;
  color: var(--color-text-secondary);
}

.keyframe-adjustment-slider-value {
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-primary);
  background: transparent;
  border: none;
  padding: 2px 6px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s ease;
  font-family: inherit;
  min-width: 36px;
  text-align: center;
}

.keyframe-adjustment-slider-value:hover {
  background: var(--color-bg-user-bubble);
}

.keyframe-adjustment-slider-value-input {
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-primary);
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  padding: 2px 4px;
  border-radius: 4px;
  font-family: inherit;
  width: 44px;
  text-align: center;
  outline: none;
  -moz-appearance: textfield;
}

.keyframe-adjustment-slider-value-input::-webkit-outer-spin-button,
.keyframe-adjustment-slider-value-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.keyframe-adjustment-slider-value-input:focus {
  border-color: var(--color-text-secondary);
}

.keyframe-adjustment-slider-track {
  position: relative;
  height: 16px;
  display: flex;
  align-items: center;
}

.keyframe-adjustment-slider-track::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 4px;
  background: var(--color-bg-input);
  border-radius: 2px;
  border: 1px solid var(--color-border-input);
}

.keyframe-adjustment-slider-input {
  appearance: none;
  width: 100%;
  height: 16px;
  background: transparent;
  cursor: pointer;
  position: relative;
  z-index: 2;
  margin: 0;
}

.keyframe-adjustment-slider-input::-webkit-slider-thumb {
  appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--color-text-primary);
  border: 2px solid var(--color-bg-canvas-surface);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  cursor: grab;
}

.keyframe-adjustment-slider-input::-webkit-slider-thumb:active {
  cursor: grabbing;
}

.keyframe-adjustment-slider-input::-moz-range-thumb {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--color-text-primary);
  border: 2px solid var(--color-bg-canvas-surface);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  cursor: grab;
}

.keyframe-adjustment-slider-input::-moz-range-thumb:active {
  cursor: grabbing;
}

.keyframe-adjustment-slider-fill {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 4px;
  background: var(--color-text-secondary);
  border-radius: 2px;
  pointer-events: none;
  opacity: 0.4;
}

/* Reset Button */
.keyframe-adjustments-reset {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  font-family: inherit;
  margin-top: 4px;
}

.keyframe-adjustments-reset:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

/* ======================
   CAMERA ANGLE CONTROL
   Enhanced 3D visualization
   ====================== */

.keyframe-camera-orbit-wrapper {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--color-border-input);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Camera Visualization */
.keyframe-camera-viz {
  background: linear-gradient(180deg, 
    var(--color-bg-canvas-surface) 0%, 
    color-mix(in srgb, var(--color-bg-canvas-surface) 95%, var(--color-text-secondary) 5%) 100%
  );
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  padding: 8px 8px 4px;
  overflow: hidden;
}

.keyframe-camera-viz-svg {
  width: 100%;
  height: auto;
  display: block;
}

/* Ground plane */
.keyframe-camera-viz-ground {
  opacity: 0.5;
}

/* Orbit ring */
.keyframe-camera-viz-orbit {
  fill: none;
  stroke: var(--color-text-secondary);
  stroke-width: 1.5;
  stroke-linecap: round;
}

.keyframe-camera-viz-orbit-front {
  opacity: 0.5;
  stroke: #22d3ee;
}

.keyframe-camera-viz-orbit-back {
  opacity: 0.2;
  stroke-dasharray: 4 6;
}

/* Cardinal direction labels */
.keyframe-camera-viz-labels {
  pointer-events: none;
}

.keyframe-camera-viz-label {
  font-size: 8px;
  font-weight: 600;
  fill: var(--color-text-secondary);
  text-anchor: middle;
  opacity: 0.5;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Connection line from image to camera */
.keyframe-camera-viz-line {
  stroke: #22d3ee;
  stroke-width: 1.5;
  stroke-dasharray: 4 4;
  opacity: 0.6;
}

.keyframe-camera-viz-line-behind {
  opacity: 0.25;
  stroke: var(--color-text-secondary);
}

/* Image group */
.keyframe-camera-viz-image-group {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
}

/* Image shadow */
.keyframe-camera-viz-image-shadow {
  fill: var(--color-text-primary);
  opacity: 0.1;
}

/* Image frame */
.keyframe-camera-viz-image {
  fill: var(--color-bg-user-bubble);
  stroke: var(--color-text-primary);
  stroke-width: 2;
}

/* Image icon elements */
.keyframe-camera-viz-img-icon {
  fill: none;
  stroke: var(--color-text-secondary);
  stroke-width: 1.5;
  opacity: 0.4;
}

.keyframe-camera-viz-img-icon-fill {
  fill: var(--color-text-secondary);
  stroke: none;
  opacity: 0.25;
}

/* Camera group */
.keyframe-camera-viz-cam-group {
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.keyframe-camera-viz-cam-behind {
  opacity: 0.4;
}

/* Camera body - main housing */
.keyframe-camera-viz-cam-body {
  fill: #1a1a1a;
  stroke: var(--color-text-secondary);
  stroke-width: 1;
  stroke-opacity: 0.5;
}

/* Camera grip */
.keyframe-camera-viz-cam-grip {
  fill: none;
  stroke: #1a1a1a;
  stroke-width: 3;
  stroke-linecap: round;
}

/* EVF/Viewfinder hump */
.keyframe-camera-viz-cam-evf {
  fill: #1a1a1a;
  stroke: var(--color-text-secondary);
  stroke-width: 1;
  stroke-opacity: 0.5;
}

/* Hot shoe mount */
.keyframe-camera-viz-cam-hotshoe {
  fill: #444;
  stroke: var(--color-text-secondary);
  stroke-width: 0.5;
  stroke-opacity: 0.3;
}

/* Mode dial */
.keyframe-camera-viz-cam-dial {
  fill: #2a2a2a;
  stroke: var(--color-text-secondary);
  stroke-width: 0.5;
  stroke-opacity: 0.4;
}

/* Shutter button */
.keyframe-camera-viz-cam-shutter {
  fill: #666;
  stroke: var(--color-text-secondary);
  stroke-width: 0.5;
  stroke-opacity: 0.3;
}

/* Lens mount ring */
.keyframe-camera-viz-lens-mount {
  fill: #222;
  stroke: var(--color-text-secondary);
  stroke-width: 1;
  stroke-opacity: 0.5;
}

/* Lens barrel */
.keyframe-camera-viz-lens-barrel {
  fill: #1a1a1a;
  stroke: var(--color-text-secondary);
  stroke-width: 1.5;
  stroke-opacity: 0.5;
}

/* Focus ring */
.keyframe-camera-viz-lens-focus {
  fill: #252525;
  stroke: var(--color-text-secondary);
  stroke-width: 0.75;
  stroke-opacity: 0.4;
}

/* Lens glass - outer */
.keyframe-camera-viz-lens-outer {
  fill: #0a1215;
  stroke: var(--color-text-secondary);
  stroke-width: 1.5;
  stroke-opacity: 0.6;
}

/* Lens glass - inner */
.keyframe-camera-viz-lens-inner {
  fill: #050a0d;
  stroke: var(--color-text-secondary);
  stroke-width: 0.5;
  stroke-opacity: 0.3;
}

/* Lens highlight/reflection */
.keyframe-camera-viz-lens-highlight {
  fill: rgba(255, 255, 255, 0.3);
  stroke: none;
}

/* Recording indicator */
.keyframe-camera-viz-rec {
  fill: #ef4444;
  stroke: none;
  animation: keyframe-rec-blink 1.5s ease-in-out infinite;
}

@keyframes keyframe-rec-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

/* View cone / field of view */
.keyframe-camera-viz-cone {
  fill: #22d3ee;
  stroke: none;
  opacity: 0.12;
}

/* Legacy class for backwards compatibility */
.keyframe-camera-viz-cam {
  fill: var(--color-text-primary);
  stroke: var(--color-bg-canvas-surface);
  stroke-width: 1;
}

.keyframe-camera-viz-lens-ring {
  fill: none;
  stroke: var(--color-text-secondary);
  stroke-width: 1.5;
  opacity: 0.6;
}

.keyframe-camera-viz-lens {
  fill: #0a1215;
  stroke: none;
}

.keyframe-camera-viz-viewfinder {
  fill: var(--color-text-primary);
  stroke: none;
  opacity: 0.8;
}

/* Camera shadow */
.keyframe-camera-viz-shadow {
  fill: var(--color-text-primary);
}

/* Height indicator */
.keyframe-camera-viz-height-indicator {
  pointer-events: none;
}

.keyframe-camera-viz-height-line {
  stroke: #a855f7;
  stroke-width: 1;
  stroke-dasharray: 2 3;
  opacity: 0.5;
}

.keyframe-camera-viz-height-dot {
  fill: #a855f7;
  opacity: 0.6;
}

/* Slider Group */
.keyframe-camera-slider-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.keyframe-camera-slider-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.keyframe-camera-slider-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.keyframe-camera-slider-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.keyframe-camera-dot-yaw {
  background: #22d3ee;
}

.keyframe-camera-dot-pitch {
  background: #a855f7;
}

.keyframe-camera-dot-dolly {
  background: #f97316;
}

.keyframe-camera-slider-value {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-secondary);
  font-variant-numeric: tabular-nums;
  min-width: 36px;
  text-align: right;
}

/* Range Slider */
.keyframe-camera-slider {
  width: 100%;
  height: 6px;
  appearance: none;
  background: var(--color-bg-input);
  border-radius: 3px;
  outline: none;
  cursor: pointer;
}

.keyframe-camera-slider::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  cursor: grab;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  -webkit-transition: transform 0.1s ease, box-shadow 0.1s ease;
  transition: transform 0.1s ease, box-shadow 0.1s ease;
}

.keyframe-camera-slider::-webkit-slider-thumb:hover {
  transform: scale(1.1);
}

.keyframe-camera-slider::-webkit-slider-thumb:active {
  cursor: grabbing;
  transform: scale(1.15);
}

.keyframe-camera-slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  cursor: grab;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  -moz-transition: transform 0.1s ease;
  transition: transform 0.1s ease;
}

/* Yaw slider - Cyan */
.keyframe-camera-slider-yaw {
  background: linear-gradient(to right, 
    var(--color-bg-input) 0%, 
    rgba(34, 211, 238, 0.3) 50%, 
    var(--color-bg-input) 100%
  );
}

.keyframe-camera-slider-yaw::-webkit-slider-thumb {
  background: #22d3ee;
}

.keyframe-camera-slider-yaw::-moz-range-thumb {
  background: #22d3ee;
}

/* Pitch slider - Purple */
.keyframe-camera-slider-pitch {
  background: linear-gradient(to right, 
    rgba(168, 85, 247, 0.2) 0%, 
    rgba(168, 85, 247, 0.4) 50%, 
    rgba(168, 85, 247, 0.2) 100%
  );
}

.keyframe-camera-slider-pitch::-webkit-slider-thumb {
  background: #a855f7;
}

.keyframe-camera-slider-pitch::-moz-range-thumb {
  background: #a855f7;
}

/* Dolly slider - Orange */
.keyframe-camera-slider-dolly {
  background: linear-gradient(to right, 
    rgba(249, 115, 22, 0.15) 0%, 
    rgba(249, 115, 22, 0.4) 100%
  );
}

.keyframe-camera-slider-dolly::-webkit-slider-thumb {
  background: #f97316;
}

.keyframe-camera-slider-dolly::-moz-range-thumb {
  background: #f97316;
}

.keyframe-camera-slider:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.keyframe-camera-slider:disabled::-webkit-slider-thumb {
  cursor: not-allowed;
}

/* Tick marks */
.keyframe-camera-slider-ticks {
  display: flex;
  justify-content: space-between;
  font-size: 9px;
  color: var(--color-text-secondary);
  opacity: 0.7;
  padding: 0 2px;
}

/* Action Buttons */
.keyframe-camera-orbit-actions {
  display: flex;
  gap: 8px;
}

.keyframe-camera-orbit-reset {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, opacity 0.15s ease;
  font-family: inherit;
  flex: 1 1;
}

.keyframe-camera-orbit-reset:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.keyframe-camera-orbit-reset:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.keyframe-camera-orbit-apply {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
  font-family: inherit;
  flex: 1.5 1;
}

.keyframe-camera-orbit-apply:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
}

.keyframe-camera-orbit-apply:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ======================
   CAMERA TOOL (advanced scene explorer + quick angle)
   ====================== */

.keyframe-camera-primary-section {
  padding-bottom: 4px;
}

.keyframe-camera-primary-desc {
  color: var(--color-text-secondary);
  font-size: 12px;
  line-height: 1.5;
  margin: 4px 0 12px;
}

.keyframe-camera-quick-section {
  margin-top: 4px;
  padding-top: 16px;
  border-top: 1px solid var(--color-border-input);
}

/* ======================
   WORLD EXPLORER CONTROLS
   ====================== */

.keyframe-world-explorer-wrapper {
  padding: 12px 0;
}

.keyframe-world-explorer-desc {
  color: var(--color-text-secondary);
  font-size: 12px;
  line-height: 1.5;
  margin: 4px 0 12px;
}

.keyframe-world-explorer-idle,
.keyframe-world-explorer-active {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.keyframe-world-explorer-status {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 600;
}

.keyframe-world-explorer-hint {
  color: var(--color-text-secondary);
  font-size: 11px;
  line-height: 1.5;
  margin: 0;
}

.keyframe-world-explorer-actions {
  display: flex;
  gap: 6px;
  margin-top: 4px;
}

.keyframe-world-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
  font-family: inherit;
  width: 100%;
}

.keyframe-world-btn:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
}

.keyframe-world-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.keyframe-world-btn-generate {
  width: 100%;
}

.keyframe-world-btn-capture {
  background: var(--color-accent-base);
  color: var(--color-text-on-accent);
  border-color: var(--color-accent-base);
  flex: 1.5 1;
}

.keyframe-world-btn-capture:hover:not(:disabled) {
  background: var(--color-accent-strong);
  border-color: var(--color-accent-strong);
  opacity: 1;
}

.keyframe-world-btn-cancel {
  flex: 1 1;
}

.keyframe-world-spinner {
  animation: worldSpinnerSpin 1s linear infinite;
}

@keyframes worldSpinnerSpin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/editor/sidebar-modes/KeyframeEditingSidebar.css"],"names":[],"mappings":"AAAA;;;;;;;2BAO2B;;AAE3B;;2BAE2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB,EAAE,uCAAuC;EAC3D,gBAAgB;EAChB,gDAAgD;EAChD,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,uGAAuG;AACzG;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;EAClC,SAAS;AACX;;AAEA;;2BAE2B;;AAE3B;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,4EAA4E;EAC5E,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,4EAA4E;EAC5E,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,mDAAmD;EACnD,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;2BAE2B;;AAE3B;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;;2BAE2B;;AAE3B;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,mDAAmD;EACnD,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;2BAE2B;;AAE3B;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qDAAqD;EACrD,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;EACrD,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;2BAE2B;;AAE3B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,mDAAmD;EACnD,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,0DAA0D;EAC1D,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,YAAY;AACd;;AAEA;;2BAE2B;;AAE3B;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;2BAE2B;;AAE3B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB;;;;;;;;;KASG;EACH,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,SAAS;EACT,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gDAAgD;EAChD,wCAAwC;EACxC,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,iCAAiC;EACjC,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gDAAgD;EAChD,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gDAAgD;EAChD,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mDAAmD;EACnD,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;;2BAG2B;;AAE3B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE;;;GAGC;EACD,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE,UAAU;EACV,mCAAmC;EACnC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA,gBAAgB;AAChB;EACE,kDAAkD;AACpD;;AAEA,iBAAiB;AACjB;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,iCAAiC;EACjC,iCAAiC;EACjC,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV,mCAAmC;EACnC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,oDAAoD;AACtD;;AAEA;EACE,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mCAAmC;EACnC,eAAe;EACf,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mCAAmC;EACnC,eAAe;EACf,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,mCAAmC;EACnC,eAAe;EACf,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,mCAAmC;EACnC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,WAAW;EAEX,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,wCAAwC;EACxC,6DAAqD;EAArD,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,wCAAwC;EACxC,oCAA+B;EAA/B,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE;;;;GAIC;AACH;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE;;;;GAIC;AACH;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE;;;GAGC;AACH;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,kCAAkC;EAClC,YAAY;EACZ,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uEAAuE;EACvE,oBAAoB;EACpB,SAAO;AACT;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;EACrD,oBAAoB;EACpB,WAAS;AACX;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;2BAE2B;;AAE3B;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;;2BAE2B;;AAE3B;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;EACtC,WAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* ======================\n   KeyframeEditingSidebar Styles\n   \n   Design System: Uses CSS variables from colors.css\n   - Neutral base palette, accent reserved for primary actions only\n   - Flat surfaces with borders (no gradients)\n   - Minimal shadows\n   ====================== */\n\n/* ======================\n   LAYOUT\n   ====================== */\n\n.keyframe-editing-sidebar {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  max-height: 100vh;\n  max-height: 100dvh; /* Dynamic viewport height for mobile */\n  overflow: hidden;\n  border-left: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n}\n\n.keyframe-editing-sidebar .sidebar-header {\n  flex: 0 0 auto;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.keyframe-editing-sidebar .header-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.keyframe-editing-sidebar .sidebar-header-title-container {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  min-width: 0;\n}\n\n.keyframe-editing-sidebar .config-back-button {\n  display: inline-flex;\n  flex: 0 0 32px;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border-color: transparent;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.1s ease;\n}\n\n.keyframe-editing-sidebar .config-back-button:hover {\n  border-color: var(--color-border-input);\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.keyframe-editing-sidebar .config-back-button:active {\n  background: var(--color-bg-input);\n  transform: translateY(1px);\n}\n\n.keyframe-editing-sidebar .config-back-button:focus-visible {\n  outline: 2px solid var(--color-text-secondary);\n  outline-offset: 2px;\n}\n\n.keyframe-editing-content {\n  flex: 1;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.keyframe-section-title {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* ======================\n   TOOLS SECTION\n   ====================== */\n\n.keyframe-tools-section {\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.keyframe-tools-section .keyframe-section-title {\n  margin-bottom: 10px;\n}\n\n.keyframe-tools-grid {\n  display: grid;\n  gap: 4px;\n}\n\n.keyframe-tool-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n  font-family: inherit;\n  aspect-ratio: 1;\n}\n\n.keyframe-tool-button:hover:not(.disabled) {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.keyframe-tool-button.active {\n  background: var(--color-bg-input);\n  border-color: var(--color-border-input);\n  color: var(--color-text-primary);\n}\n\n.keyframe-tool-button.disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n/* ======================\n   COLOR PICKER\n   ====================== */\n\n.keyframe-color-picker-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.keyframe-color-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n}\n\n.keyframe-color-picker {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  cursor: pointer;\n  background: transparent;\n}\n\n.keyframe-color-picker::-webkit-color-swatch-wrapper {\n  padding: 2px;\n}\n\n.keyframe-color-picker::-webkit-color-swatch {\n  border-radius: 4px;\n  border: none;\n}\n\n/* ======================\n   PEN OPTIONS (Color + Eraser)\n   ====================== */\n\n.keyframe-pen-options {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.keyframe-pen-options .keyframe-color-picker-wrapper {\n  margin-top: 0;\n  padding-top: 0;\n  border-top: none;\n  flex: 1;\n}\n\n.keyframe-eraser-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n  font-family: inherit;\n  flex-shrink: 0;\n}\n\n.keyframe-eraser-button:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n/* Eraser mode active state */\n.keyframe-eraser-active {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.keyframe-eraser-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n}\n\n.keyframe-back-to-pen-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 5px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  font-family: inherit;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.keyframe-back-to-pen-button:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n/* ======================\n   VERSIONS SECTION\n   ====================== */\n\n.keyframe-versions-section {\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.keyframe-version-restore-btn {\n  border: 1px solid var(--color-border-input);\n  border-radius: 5px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 11px;\n  font-weight: 600;\n  padding: 6px 10px;\n  cursor: pointer;\n}\n\n.keyframe-version-restore-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.keyframe-version-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.keyframe-version-item {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  width: 100%;\n  padding: 0;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  overflow: hidden;\n}\n\n.keyframe-version-item:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.keyframe-version-item.selected {\n  background: var(--color-bg-user-bubble);\n  border-color: var(--color-text-primary);\n}\n\n.keyframe-version-item.current {\n  border-color: var(--color-text-secondary);\n}\n\n.keyframe-version-item-rail {\n  display: none;\n}\n\n.keyframe-version-item.current .keyframe-version-item-rail {\n  display: none;\n}\n\n.keyframe-version-item-thumb {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  object-fit: cover;\n  border-radius: 6px 6px 0 0;\n  border: none;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.keyframe-version-item-copy {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  min-width: 0;\n}\n\n.keyframe-version-item-label {\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.keyframe-version-item-time {\n  color: var(--color-text-secondary);\n  font-size: 11px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.keyframe-version-current-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: var(--color-text-primary);\n  margin-left: auto;\n}\n\n/* ======================\n   HISTORY SECTION\n   ====================== */\n\n.keyframe-history-section {\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  padding: 12px;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.keyframe-history-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.keyframe-history-actions {\n  display: flex;\n  gap: 4px;\n}\n\n.keyframe-history-action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  border: 1px solid var(--color-border-input);\n  border-radius: 5px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  font-family: inherit;\n}\n\n.keyframe-history-action-btn:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.keyframe-history-action-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.keyframe-history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n  max-height: 180px;\n}\n\n.keyframe-history-empty {\n  text-align: center;\n  padding: 20px 8px;\n  color: var(--color-text-secondary);\n}\n\n.keyframe-history-empty p {\n  margin: 0;\n  font-size: 13px;\n}\n\n.keyframe-history-empty-hint {\n  font-size: 11px !important;\n  margin-top: 4px !important;\n  opacity: 0.6;\n}\n\n.keyframe-history-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 6px 10px;\n  border-radius: 5px;\n  background: transparent;\n  border: none;\n  transition: background 0.15s ease;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n  width: 100%;\n}\n\n.keyframe-history-item:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.keyframe-history-item.current {\n  background: var(--color-bg-input);\n}\n\n.keyframe-history-item.future {\n  opacity: 0.4;\n}\n\n.keyframe-history-item.future:hover {\n  opacity: 0.6;\n}\n\n.keyframe-history-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  min-width: 0;\n}\n\n.keyframe-history-current-badge {\n  font-size: 9px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  padding: 2px 5px;\n  background: var(--color-bg-user-bubble);\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n/* ======================\n   SAVE BAR\n   ====================== */\n\n.keyframe-save-bar {\n  position: sticky;\n  bottom: 0;\n  padding: 12px 16px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.keyframe-export-button {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: background 0.15s ease, opacity 0.15s ease;\n  font-family: inherit;\n}\n\n.keyframe-export-button:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.keyframe-export-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.keyframe-save-button {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n  font-family: inherit;\n}\n\n.keyframe-save-button:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.keyframe-save-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ======================\n   STICKER/ASSETS SECTION\n   ====================== */\n\n.keyframe-sticker-assets-wrapper {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--color-border-input);\n  max-height: 280px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 4px;\n}\n\n.keyframe-sticker-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.keyframe-sticker-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n}\n\n.keyframe-create-asset-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 5px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  font-family: inherit;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.keyframe-create-asset-button:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.keyframe-sticker-assets-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n  width: 100%;\n  max-width: 100%;\n}\n\n.keyframe-sticker-asset-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 8px;\n  background: transparent;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.keyframe-sticker-asset-card:hover:not(.disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.keyframe-sticker-asset-card.disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.keyframe-sticker-asset-image-wrapper {\n  width: 100%;\n  aspect-ratio: 1;\n  border-radius: 4px;\n  overflow: hidden;\n  background: var(--color-bg-input);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  border: 1px solid var(--color-border-input);\n}\n\n.keyframe-sticker-asset-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.keyframe-sticker-asset-placeholder {\n  color: var(--color-text-secondary);\n  opacity: 0.5;\n}\n\n.keyframe-sticker-asset-name {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n  width: 100%;\n  min-width: 0;\n  line-height: 1.2;\n}\n\n.keyframe-sticker-empty {\n  text-align: center;\n  padding: 16px 8px;\n  color: var(--color-text-secondary);\n}\n\n.keyframe-sticker-empty p {\n  margin: 0;\n  font-size: 13px;\n}\n\n.keyframe-sticker-empty-hint {\n  font-size: 11px !important;\n  margin-top: 4px !important;\n  opacity: 0.6;\n}\n\n/* ======================\n   DROPDOWN MENU\n   ====================== */\n\n.keyframe-assets-dropdown-content {\n  min-width: 160px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  padding: 4px;\n  z-index: 1000;\n}\n\n.keyframe-assets-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 5px;\n  font-size: 13px;\n  color: var(--color-text-primary);\n  cursor: pointer;\n  outline: none;\n  transition: background 0.15s ease;\n}\n\n.keyframe-assets-dropdown-item[data-highlighted] {\n  background: var(--color-bg-user-bubble);\n}\n\n.keyframe-assets-dropdown-icon {\n  color: var(--color-text-secondary);\n  flex-shrink: 0;\n}\n\n/* ======================\n   COLOR ADJUSTMENTS\n   ====================== */\n\n.keyframe-adjustments-wrapper {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--color-border-input);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.keyframe-adjustments-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n  margin-bottom: 8px;\n  display: block;\n}\n\n/* Color Wheel */\n.keyframe-color-wheel-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.keyframe-color-wheel {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  position: relative;\n  cursor: crosshair;\n  border: 1px solid var(--color-border-input);\n  overflow: hidden;\n  background: var(--color-bg-input);\n}\n\n.keyframe-color-wheel-gradient {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background: \n    radial-gradient(circle at center, transparent 0%, transparent 60%, var(--color-bg-input) 100%),\n    conic-gradient(\n      from 180deg,\n      #ff9500 0deg,      /* warm/orange */\n      #ff2d92 90deg,     /* magenta */\n      #5856d6 180deg,    /* cool/blue */\n      #34c759 270deg,    /* green */\n      #ff9500 360deg     /* warm/orange */\n    );\n  opacity: 0.6;\n}\n\n.keyframe-color-wheel-crosshair {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.keyframe-color-wheel-crosshair-h,\n.keyframe-color-wheel-crosshair-v {\n  position: absolute;\n  background: var(--color-border-input);\n}\n\n.keyframe-color-wheel-crosshair-h {\n  left: 10%;\n  right: 10%;\n  top: 50%;\n  height: 1px;\n  transform: translateY(-50%);\n}\n\n.keyframe-color-wheel-crosshair-v {\n  top: 10%;\n  bottom: 10%;\n  left: 50%;\n  width: 1px;\n  transform: translateX(-50%);\n}\n\n.keyframe-color-wheel-indicator {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: var(--color-text-primary);\n  border: 2px solid var(--color-bg-canvas-surface);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n}\n\n/* Adjustment Sliders */\n.keyframe-adjustments-sliders {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.keyframe-adjustment-slider {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.keyframe-adjustment-slider-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.keyframe-adjustment-slider-label {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n}\n\n.keyframe-adjustment-slider-value {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  background: transparent;\n  border: none;\n  padding: 2px 6px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  font-family: inherit;\n  min-width: 36px;\n  text-align: center;\n}\n\n.keyframe-adjustment-slider-value:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.keyframe-adjustment-slider-value-input {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  padding: 2px 4px;\n  border-radius: 4px;\n  font-family: inherit;\n  width: 44px;\n  text-align: center;\n  outline: none;\n  -moz-appearance: textfield;\n}\n\n.keyframe-adjustment-slider-value-input::-webkit-outer-spin-button,\n.keyframe-adjustment-slider-value-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.keyframe-adjustment-slider-value-input:focus {\n  border-color: var(--color-text-secondary);\n}\n\n.keyframe-adjustment-slider-track {\n  position: relative;\n  height: 16px;\n  display: flex;\n  align-items: center;\n}\n\n.keyframe-adjustment-slider-track::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 4px;\n  background: var(--color-bg-input);\n  border-radius: 2px;\n  border: 1px solid var(--color-border-input);\n}\n\n.keyframe-adjustment-slider-input {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  height: 16px;\n  background: transparent;\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n  margin: 0;\n}\n\n.keyframe-adjustment-slider-input::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: var(--color-text-primary);\n  border: 2px solid var(--color-bg-canvas-surface);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  cursor: grab;\n}\n\n.keyframe-adjustment-slider-input::-webkit-slider-thumb:active {\n  cursor: grabbing;\n}\n\n.keyframe-adjustment-slider-input::-moz-range-thumb {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: var(--color-text-primary);\n  border: 2px solid var(--color-bg-canvas-surface);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  cursor: grab;\n}\n\n.keyframe-adjustment-slider-input::-moz-range-thumb:active {\n  cursor: grabbing;\n}\n\n.keyframe-adjustment-slider-fill {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 4px;\n  background: var(--color-text-secondary);\n  border-radius: 2px;\n  pointer-events: none;\n  opacity: 0.4;\n}\n\n/* Reset Button */\n.keyframe-adjustments-reset {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  font-family: inherit;\n  margin-top: 4px;\n}\n\n.keyframe-adjustments-reset:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n/* ======================\n   CAMERA ANGLE CONTROL\n   Enhanced 3D visualization\n   ====================== */\n\n.keyframe-camera-orbit-wrapper {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--color-border-input);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Camera Visualization */\n.keyframe-camera-viz {\n  background: linear-gradient(180deg, \n    var(--color-bg-canvas-surface) 0%, \n    color-mix(in srgb, var(--color-bg-canvas-surface) 95%, var(--color-text-secondary) 5%) 100%\n  );\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  padding: 8px 8px 4px;\n  overflow: hidden;\n}\n\n.keyframe-camera-viz-svg {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* Ground plane */\n.keyframe-camera-viz-ground {\n  opacity: 0.5;\n}\n\n/* Orbit ring */\n.keyframe-camera-viz-orbit {\n  fill: none;\n  stroke: var(--color-text-secondary);\n  stroke-width: 1.5;\n  stroke-linecap: round;\n}\n\n.keyframe-camera-viz-orbit-front {\n  opacity: 0.5;\n  stroke: #22d3ee;\n}\n\n.keyframe-camera-viz-orbit-back {\n  opacity: 0.2;\n  stroke-dasharray: 4 6;\n}\n\n/* Cardinal direction labels */\n.keyframe-camera-viz-labels {\n  pointer-events: none;\n}\n\n.keyframe-camera-viz-label {\n  font-size: 8px;\n  font-weight: 600;\n  fill: var(--color-text-secondary);\n  text-anchor: middle;\n  opacity: 0.5;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Connection line from image to camera */\n.keyframe-camera-viz-line {\n  stroke: #22d3ee;\n  stroke-width: 1.5;\n  stroke-dasharray: 4 4;\n  opacity: 0.6;\n}\n\n.keyframe-camera-viz-line-behind {\n  opacity: 0.25;\n  stroke: var(--color-text-secondary);\n}\n\n/* Image group */\n.keyframe-camera-viz-image-group {\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));\n}\n\n/* Image shadow */\n.keyframe-camera-viz-image-shadow {\n  fill: var(--color-text-primary);\n  opacity: 0.1;\n}\n\n/* Image frame */\n.keyframe-camera-viz-image {\n  fill: var(--color-bg-user-bubble);\n  stroke: var(--color-text-primary);\n  stroke-width: 2;\n}\n\n/* Image icon elements */\n.keyframe-camera-viz-img-icon {\n  fill: none;\n  stroke: var(--color-text-secondary);\n  stroke-width: 1.5;\n  opacity: 0.4;\n}\n\n.keyframe-camera-viz-img-icon-fill {\n  fill: var(--color-text-secondary);\n  stroke: none;\n  opacity: 0.25;\n}\n\n/* Camera group */\n.keyframe-camera-viz-cam-group {\n  transition: transform 0.15s ease, opacity 0.15s ease;\n}\n\n.keyframe-camera-viz-cam-behind {\n  opacity: 0.4;\n}\n\n/* Camera body - main housing */\n.keyframe-camera-viz-cam-body {\n  fill: #1a1a1a;\n  stroke: var(--color-text-secondary);\n  stroke-width: 1;\n  stroke-opacity: 0.5;\n}\n\n/* Camera grip */\n.keyframe-camera-viz-cam-grip {\n  fill: none;\n  stroke: #1a1a1a;\n  stroke-width: 3;\n  stroke-linecap: round;\n}\n\n/* EVF/Viewfinder hump */\n.keyframe-camera-viz-cam-evf {\n  fill: #1a1a1a;\n  stroke: var(--color-text-secondary);\n  stroke-width: 1;\n  stroke-opacity: 0.5;\n}\n\n/* Hot shoe mount */\n.keyframe-camera-viz-cam-hotshoe {\n  fill: #444;\n  stroke: var(--color-text-secondary);\n  stroke-width: 0.5;\n  stroke-opacity: 0.3;\n}\n\n/* Mode dial */\n.keyframe-camera-viz-cam-dial {\n  fill: #2a2a2a;\n  stroke: var(--color-text-secondary);\n  stroke-width: 0.5;\n  stroke-opacity: 0.4;\n}\n\n/* Shutter button */\n.keyframe-camera-viz-cam-shutter {\n  fill: #666;\n  stroke: var(--color-text-secondary);\n  stroke-width: 0.5;\n  stroke-opacity: 0.3;\n}\n\n/* Lens mount ring */\n.keyframe-camera-viz-lens-mount {\n  fill: #222;\n  stroke: var(--color-text-secondary);\n  stroke-width: 1;\n  stroke-opacity: 0.5;\n}\n\n/* Lens barrel */\n.keyframe-camera-viz-lens-barrel {\n  fill: #1a1a1a;\n  stroke: var(--color-text-secondary);\n  stroke-width: 1.5;\n  stroke-opacity: 0.5;\n}\n\n/* Focus ring */\n.keyframe-camera-viz-lens-focus {\n  fill: #252525;\n  stroke: var(--color-text-secondary);\n  stroke-width: 0.75;\n  stroke-opacity: 0.4;\n}\n\n/* Lens glass - outer */\n.keyframe-camera-viz-lens-outer {\n  fill: #0a1215;\n  stroke: var(--color-text-secondary);\n  stroke-width: 1.5;\n  stroke-opacity: 0.6;\n}\n\n/* Lens glass - inner */\n.keyframe-camera-viz-lens-inner {\n  fill: #050a0d;\n  stroke: var(--color-text-secondary);\n  stroke-width: 0.5;\n  stroke-opacity: 0.3;\n}\n\n/* Lens highlight/reflection */\n.keyframe-camera-viz-lens-highlight {\n  fill: rgba(255, 255, 255, 0.3);\n  stroke: none;\n}\n\n/* Recording indicator */\n.keyframe-camera-viz-rec {\n  fill: #ef4444;\n  stroke: none;\n  animation: keyframe-rec-blink 1.5s ease-in-out infinite;\n}\n\n@keyframes keyframe-rec-blink {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.3; }\n}\n\n/* View cone / field of view */\n.keyframe-camera-viz-cone {\n  fill: #22d3ee;\n  stroke: none;\n  opacity: 0.12;\n}\n\n/* Legacy class for backwards compatibility */\n.keyframe-camera-viz-cam {\n  fill: var(--color-text-primary);\n  stroke: var(--color-bg-canvas-surface);\n  stroke-width: 1;\n}\n\n.keyframe-camera-viz-lens-ring {\n  fill: none;\n  stroke: var(--color-text-secondary);\n  stroke-width: 1.5;\n  opacity: 0.6;\n}\n\n.keyframe-camera-viz-lens {\n  fill: #0a1215;\n  stroke: none;\n}\n\n.keyframe-camera-viz-viewfinder {\n  fill: var(--color-text-primary);\n  stroke: none;\n  opacity: 0.8;\n}\n\n/* Camera shadow */\n.keyframe-camera-viz-shadow {\n  fill: var(--color-text-primary);\n}\n\n/* Height indicator */\n.keyframe-camera-viz-height-indicator {\n  pointer-events: none;\n}\n\n.keyframe-camera-viz-height-line {\n  stroke: #a855f7;\n  stroke-width: 1;\n  stroke-dasharray: 2 3;\n  opacity: 0.5;\n}\n\n.keyframe-camera-viz-height-dot {\n  fill: #a855f7;\n  opacity: 0.6;\n}\n\n/* Slider Group */\n.keyframe-camera-slider-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.keyframe-camera-slider-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.keyframe-camera-slider-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.keyframe-camera-slider-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.keyframe-camera-dot-yaw {\n  background: #22d3ee;\n}\n\n.keyframe-camera-dot-pitch {\n  background: #a855f7;\n}\n\n.keyframe-camera-dot-dolly {\n  background: #f97316;\n}\n\n.keyframe-camera-slider-value {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  font-variant-numeric: tabular-nums;\n  min-width: 36px;\n  text-align: right;\n}\n\n/* Range Slider */\n.keyframe-camera-slider {\n  width: 100%;\n  height: 6px;\n  -webkit-appearance: none;\n  appearance: none;\n  background: var(--color-bg-input);\n  border-radius: 3px;\n  outline: none;\n  cursor: pointer;\n}\n\n.keyframe-camera-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  cursor: grab;\n  border: 2px solid white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  transition: transform 0.1s ease, box-shadow 0.1s ease;\n}\n\n.keyframe-camera-slider::-webkit-slider-thumb:hover {\n  transform: scale(1.1);\n}\n\n.keyframe-camera-slider::-webkit-slider-thumb:active {\n  cursor: grabbing;\n  transform: scale(1.15);\n}\n\n.keyframe-camera-slider::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  cursor: grab;\n  border: 2px solid white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  transition: transform 0.1s ease;\n}\n\n/* Yaw slider - Cyan */\n.keyframe-camera-slider-yaw {\n  background: linear-gradient(to right, \n    var(--color-bg-input) 0%, \n    rgba(34, 211, 238, 0.3) 50%, \n    var(--color-bg-input) 100%\n  );\n}\n\n.keyframe-camera-slider-yaw::-webkit-slider-thumb {\n  background: #22d3ee;\n}\n\n.keyframe-camera-slider-yaw::-moz-range-thumb {\n  background: #22d3ee;\n}\n\n/* Pitch slider - Purple */\n.keyframe-camera-slider-pitch {\n  background: linear-gradient(to right, \n    rgba(168, 85, 247, 0.2) 0%, \n    rgba(168, 85, 247, 0.4) 50%, \n    rgba(168, 85, 247, 0.2) 100%\n  );\n}\n\n.keyframe-camera-slider-pitch::-webkit-slider-thumb {\n  background: #a855f7;\n}\n\n.keyframe-camera-slider-pitch::-moz-range-thumb {\n  background: #a855f7;\n}\n\n/* Dolly slider - Orange */\n.keyframe-camera-slider-dolly {\n  background: linear-gradient(to right, \n    rgba(249, 115, 22, 0.15) 0%, \n    rgba(249, 115, 22, 0.4) 100%\n  );\n}\n\n.keyframe-camera-slider-dolly::-webkit-slider-thumb {\n  background: #f97316;\n}\n\n.keyframe-camera-slider-dolly::-moz-range-thumb {\n  background: #f97316;\n}\n\n.keyframe-camera-slider:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.keyframe-camera-slider:disabled::-webkit-slider-thumb {\n  cursor: not-allowed;\n}\n\n/* Tick marks */\n.keyframe-camera-slider-ticks {\n  display: flex;\n  justify-content: space-between;\n  font-size: 9px;\n  color: var(--color-text-secondary);\n  opacity: 0.7;\n  padding: 0 2px;\n}\n\n/* Action Buttons */\n.keyframe-camera-orbit-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.keyframe-camera-orbit-reset {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, opacity 0.15s ease;\n  font-family: inherit;\n  flex: 1;\n}\n\n.keyframe-camera-orbit-reset:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.keyframe-camera-orbit-reset:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.keyframe-camera-orbit-apply {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 16px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n  font-family: inherit;\n  flex: 1.5;\n}\n\n.keyframe-camera-orbit-apply:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.keyframe-camera-orbit-apply:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ======================\n   CAMERA TOOL (advanced scene explorer + quick angle)\n   ====================== */\n\n.keyframe-camera-primary-section {\n  padding-bottom: 4px;\n}\n\n.keyframe-camera-primary-desc {\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 4px 0 12px;\n}\n\n.keyframe-camera-quick-section {\n  margin-top: 4px;\n  padding-top: 16px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n/* ======================\n   WORLD EXPLORER CONTROLS\n   ====================== */\n\n.keyframe-world-explorer-wrapper {\n  padding: 12px 0;\n}\n\n.keyframe-world-explorer-desc {\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 4px 0 12px;\n}\n\n.keyframe-world-explorer-idle,\n.keyframe-world-explorer-active {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.keyframe-world-explorer-status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.keyframe-world-explorer-hint {\n  color: var(--color-text-secondary);\n  font-size: 11px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.keyframe-world-explorer-actions {\n  display: flex;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.keyframe-world-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 6px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, opacity 0.15s;\n  font-family: inherit;\n  width: 100%;\n}\n\n.keyframe-world-btn:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.keyframe-world-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.keyframe-world-btn-generate {\n  width: 100%;\n}\n\n.keyframe-world-btn-capture {\n  background: var(--color-accent-base);\n  color: var(--color-text-on-accent);\n  border-color: var(--color-accent-base);\n  flex: 1.5;\n}\n\n.keyframe-world-btn-capture:hover:not(:disabled) {\n  background: var(--color-accent-strong);\n  border-color: var(--color-accent-strong);\n  opacity: 1;\n}\n\n.keyframe-world-btn-cancel {\n  flex: 1;\n}\n\n.keyframe-world-spinner {\n  animation: worldSpinnerSpin 1s linear infinite;\n}\n\n@keyframes worldSpinnerSpin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
